import { render, staticRenderFns } from "./TaskCenter.vue?vue&type=template&id=1d230a1a&scoped=true&"
import script from "./TaskCenter.vue?vue&type=script&lang=js&"
export * from "./TaskCenter.vue?vue&type=script&lang=js&"
import style0 from "./TaskCenter.vue?vue&type=style&index=0&id=1d230a1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d230a1a",
  null
  
)

export default component.exports